import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import { selectScopesInStore, selectScopesPageLoading, selectScopesShowInitWaitingMessage } from '../_selectors/scope.selectors';

export class ScopesDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectScopesPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectScopesShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectScopesInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
